import { useNavigate } from "react-router-dom";
import styles from "./Modal.module.css";
import { IoCloseOutline } from "react-icons/io5";
import { IoClose } from "react-icons/io5";
import { CgClose } from "react-icons/cg";

const Modal = ({
  children,
  isModalOpen,
  setIsModalOpen,
  closable,
  svgBg,
  className,
  pinkBg,
  viewBox,
  wideModal,
  contentClass,
  onClose,
}) => {
  const navigate = useNavigate();
  const showModal = () => {
    setIsModalOpen(true);
  };
  // const handleOk = () => {
  //   setIsModalOpen(false);
  //   navigate("/membership");
  // };
  const handleCancel = () => {
    if (onClose) onClose();
    setIsModalOpen(false);
  };
  // console.log("modaaaaaaaaa", isModalOpen);
  return (
    <div
      id="myModal"
      className={svgBg ? styles.modal : pinkBg ? styles.pinkBg : styles.grayBg}
      style={{
        display: isModalOpen ? "block" : "none",
      }}
    >
      {svgBg && (
        <svg
          className={styles.starBg}
          viewBox={viewBox}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {svgBg}
        </svg>
      )}
      <div
        className={`${styles.modalContent} ${className} ${
          wideModal && styles.wideModal
        }`}
      >
        <div className={styles.modalHeader}>
          {closable && (
            <span className={styles.close} onClick={handleCancel}>
              {/* &times; */}
              <CgClose className={styles.closeIcon} />
            </span>
          )}
        </div>
        <div className={` ${styles.modalBody} ${contentClass}`}>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
